import React, { useState } from 'react';
import PrivacyPolicyModal from './PrivacyPolicyModal';
import TermsOfServiceModal from './TermsOfServiceModal';
import HelpFaqModal from './HelpFaqModal';
import { useTheme } from '../context/ThemeContext';

const Footer = () => {
  const [isPrivacyPolicyOpen, setIsPrivacyPolicyOpen] = useState(false);
  const [isTermsOfServiceOpen, setIsTermsOfServiceOpen] = useState(false);
  const [isHelpFaqOpen, setIsHelpFaqOpen] = useState(false);
  const { theme, themes } = useTheme();
  const isDarkTheme = themes[theme]?.mode === 'dark';

  return (
    <footer className={`flex flex-col gap-3 border-t px-6 py-4 text-sm sm:flex-row sm:items-center sm:justify-between ${
      isDarkTheme ? 'border-white/15 text-gray-300' : 'border-gray-400/30 text-gray-700'
    }`}>
      <span className="text-xs opacity-80">© EzNoteManagerPro</span>

      <nav aria-label="Support and legal links" className="flex flex-wrap items-center gap-x-4 gap-y-2">
        <button type="button" onClick={() => setIsHelpFaqOpen(true)} className="hover:underline">Help & FAQ</button>
        <button type="button" onClick={() => setIsPrivacyPolicyOpen(true)} className="hover:underline">Privacy</button>
        <button type="button" onClick={() => setIsTermsOfServiceOpen(true)} className="hover:underline">Terms</button>
        <a href="mailto:contact@eznotemanagerpro.com" className="hover:underline">Contact</a>
        <a href="#top" className="hover:underline">Back to top</a>
      </nav>

      {/* Privacy Policy Modal */}
      <PrivacyPolicyModal 
        isOpen={isPrivacyPolicyOpen} 
        onRequestClose={() => setIsPrivacyPolicyOpen(false)} 
      />

      {/* Terms of Service Modal */}
      <TermsOfServiceModal 
        isOpen={isTermsOfServiceOpen} 
        onRequestClose={() => setIsTermsOfServiceOpen(false)} 
      />

      {/* Help/FAQ Modal */}
      <HelpFaqModal 
        isOpen={isHelpFaqOpen} 
        onRequestClose={() => setIsHelpFaqOpen(false)} 
      />
    </footer>
  );
};

export default Footer;
